import type { NotificationOptionsState } from './NotificationOptionSchema';
import { createStore } from 'owa-satcheljs';

const defaultExport: () => NotificationOptionsState = createStore<NotificationOptionsState>(
    'notificationOptions',
    {
        prevState: undefined,
        global: undefined,
        typesEnabled: new Map(),
        mail: undefined,
        calendar: undefined,
        document: undefined,
    }
);
export default defaultExport;
